import React, { useState, useRef, useEffect } from 'react';

import IconWithText from 'components/Widgets/IconWithText';
import {
  Button,
} from 'react-bootstrap5';

import AiVideo from 'components/AiVideo/Index';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import useSize from 'components/Common/Screen/Hooks/useSize';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useContext } from './Context';

import VideoDescriptionPopup from './VideoDescriptionPopup';
import SessionFeedback from './SessionFeedback/Index';

import ChatList from './ChatList';
import Chat from './Chat';

export default function Content() {
  const [fullWidth, setFullWidth] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const [showVideDescriptionPopup, setShowVideoDescriptionPopup] = useState(false);
  const [showChatList, setShowChatList] = useState(false);
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const [isReturnToWorkFirstAiSession, setIsReturnToWorkFirstAiSession] = useState(false);
  const [isAiDebrief, setIsAiDebrief] = useState(false);

  const { dispatch, actions, state } = useContext();

  const wrapper = useRef(null);
  const size = useSize(wrapper);

  const isFullModeViw = size && size.width > 1024;

  const openAiPartIfClose = () => {
    if (!document.body.classList.contains('page-chat-open')) {
      document.body.classList.add('page-chat-open');
    }
  };

  const onCloseChat = () => {
    // document.querySelector('.navigation-ai-coach-chat').click();
    document.body.classList.remove('page-chat-open');
    window.aiChatOpen = false;
  };

  const onShowChatList = () => {
    setShowChatList((prev) => !prev);
  };

  const onOpenVideo = (message = '') => {
    setWelcomeMessage(message);
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    disableBodyScroll(document.body);
    setShowVideo(true);
  };

  const onOpenVideoDescriptionPopup = () => {
    if (state.avatar.attributes.skip_ai_session_description) {
      onOpenVideo();
    } else {
      setShowVideoDescriptionPopup(true);
    }
  };

  const onCloseVideo = () => {
    enableBodyScroll(document.body);
    setShowVideo(false);
    if (isReturnToWorkFirstAiSession) {
      const event = new CustomEvent('ReturnToWorkCheckCoachingReadinessScore');
      window.dispatchEvent(event);
      setIsReturnToWorkFirstAiSession(false);
    } else if (isAiDebrief) {
      const event = new CustomEvent('AiDebriefCheckCoachingReadinessScore');
      window.dispatchEvent(event);
      setIsAiDebrief(false);
    } else {
      setShowFeedback(true);
    }
  };

  const onCloseByTimeout = (type) => {
    let text = 'Your coaching session has reached its 10-minute time limit. We hope you found this '
        + 'conversation valuable! To continue your coaching journey, start a new session!';

    if (type === 'inactive') {
      text = 'Your coaching session has ended due to inactivity. '
        + 'To continue your coaching journey, start a new session!';
    }

    onCloseVideo();
    confirmAlert({
      title: 'Session Ended',
      text,
      confirmButtonText: 'New Session',
    }, () => {
      onOpenVideoDescriptionPopup();
    });
  };

  const onFullWidthClick = () => {
    if (fullWidth) {
      document.body.classList.remove('full-page-chat-view');
      setFullWidth(false);
    } else {
      document.body.classList.add('full-page-chat-view');
      setFullWidth(true);
    }
  };

  const onNewChatClick = () => {
    actions.setNewChat(dispatch);
  };

  useEffect(() => {
    if (showChatList && state.currentChatTrigger === 'click') {
      setShowChatList(false);
    }
  }, [state.currentChat?.id, state.startSessionDate]);

  useEffect(() => {
    if (showVideo) {
      document.body.classList.add('full-page-video-view');
    } else {
      document.body.classList.remove('full-page-video-view');
    }
  }, [showVideo]);

  useEffect(() => {
    const handleEvent = (event) => {
      openAiPartIfClose();

      onOpenVideo(event?.detail?.welcomeMessage || '');
      if (event?.detail?.isReturnToWorkFirstAiSession) {
        setIsReturnToWorkFirstAiSession(true);
      }
      if (event?.detail?.isAiDebrief) {
        setIsAiDebrief(true);
      }
    };

    window.addEventListener('ReturnToWorkFirstAiSession', handleEvent);

    return () => {
      window.removeEventListener('ReturnToWorkFirstAiSession', handleEvent);
    };
  }, []);

  return (
    <div ref={wrapper} className="height-100">
      <div className="d-flex justify-content-between align-items-center mb-3">

        <h4 className="mb-0">{state.avatar.attributes.name}</h4>
        <div className="col-auto">
          <Button
            variant="link"
            className="p-0"
            onClick={() => onOpenVideoDescriptionPopup()}
          >
            <IconWithText
              iconClassName="camera-icon small-icon"
              wrapperClassName="p-2"
            />
          </Button>
          {!isFullModeViw && (
          <Button
            variant="link"
            className=" p-0"
            onClick={onShowChatList}
          >
            <IconWithText
              iconClassName="categories-icon small-icon"
              wrapperClassName="p-2"
            />
          </Button>
          )}
          <Button
            variant="link"
            className="change-size-icon p-0"
            onClick={onFullWidthClick}
          >
            <IconWithText
              iconClassName={`${fullWidth ? 'arrow-left-v2-icon' : 'arrow-right-v2-icon'} small-icon`}
              wrapperClassName="p-2"
            />
          </Button>
          <Button
            variant="link"
            className=" p-0"
            onClick={onCloseChat}
          >
            <IconWithText
              iconClassName="close-icon small-icon"
              wrapperClassName="p-2"
            />
          </Button>
        </div>
      </div>

      <div className="row height-100 without-header">
        {(isFullModeViw || showChatList) && (
        <div className="col-auto chats-list " style={!isFullModeViw ? { width: '100%' } : {}}>
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              {!isFullModeViw && showChatList ? (
                <Button
                  variant=""
                  className="p-0"
                  onClick={() => setShowChatList(false)}
                >
                  <IconWithText
                    iconClassName="arrow-left-v2-icon small-icon"
                    wrapperClassName="p-2"
                  >
                    Chat
                  </IconWithText>
                </Button>
              ) : <div className="ms-2">Conversations</div> }

              <Button
                variant=""
                className="p-0"
                onClick={onNewChatClick}
              >
                <IconWithText
                  iconClassName="new-chat-icon small-icon"
                  wrapperClassName="p-2"
                />
              </Button>
            </div>
          </div>
          <ChatList />
        </div>
        )}
        <div className={`col height-100 ${showChatList && !isFullModeViw ? 'd-none' : ''}`}>
          <Chat
            key={state.currentChat === null
              ? `new-chat-${state.startSessionDate}`
              : `chat-${state.currentChat.id}-${state.startSessionDate}`}
            onOpenVideo={() => onOpenVideoDescriptionPopup()}
          />
        </div>
      </div>

      <VideoDescriptionPopup
        show={showVideDescriptionPopup}
        onClose={() => setShowVideoDescriptionPopup(false)}
        onStart={onOpenVideo}
      />

      <SessionFeedback
        show={showFeedback}
        onClose={() => setShowFeedback(false)}
      />

      {showVideo && (
      <AiVideo
        welcomeMessage={welcomeMessage}
        onClose={onCloseVideo}
        onCloseByTimeout={onCloseByTimeout}
      />
      )}
    </div>
  );
}
